import React, { Component } from 'react'
import './styles.css'
import { connect } from 'react-redux'
import * as actions from '../../containers/inventoryView/actions'
import moment from 'moment'
import CalendarTile from './calendarTile'
import { WEEK_DAYS } from '../../utils/constants';
class InventorycalendarView extends Component {

  componentDidMount() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const provider_id = this.props.allRoutesInfo.provider_id || localStorage.getItem('provider-id');
    const operator_id = this.props.allRoutesInfo.operator_id || localStorage.getItem('operator-id');
    const duration = 60;
    this.props.fetchInventoryCalendarView({ provider_id, operator_id, duration });
  }

  getDates(startDate, stopDate) {
    var dateArray = [];
    var currentDate = moment(startDate);
    var endDate = moment(stopDate);
    while (currentDate <= endDate) {
      dateArray.push(moment(currentDate).format('YYYY-MM-DD'))
      currentDate = moment(currentDate).add(1, 'days');
    }
    let updatedDates = dateArray.slice(0, -1);
    return updatedDates;
  }

  isDisabledTile(date, index, dates, monthNumber, disabledDays) {
    if(disabledDays.includes(date)){
      return true;
    }
    else{
      return false;
    }
  }

  getDateServicesRejections(date, responseDateArray) {
    let resultObj = {}
    responseDateArray.forEach((item, index) => {
      if (item.date === date) {
        resultObj = this.props.inventoryCalendarViewData.calendar_data[index];
      }
      else {
        return;
      }
    })
    return resultObj;
  }

  isInventoryDataPresent(date, isDataPresentDates) {
    return isDataPresentDates.includes(date)
  }

  renderInventorycalendar(dates, responseDateArray, monthNumber) {
    let finalResult;
    const firstDay = dates && new Date(dates[0]);
    const numberOfDisabledDays = moment(firstDay).format("d");
    const lastDisabledDate = moment(firstDay).subtract(numberOfDisabledDays,'d').format('YYYY-MM-DD'); //to know the disabled dates in the week, it's (current date - the  number of disabled days in a week) 
    const disabledDays = this.getDates(lastDisabledDate, firstDay);
    const allDates = [...disabledDays, ...dates];
    finalResult = allDates.map((date, index) => {
          return (
            this.isDisabledTile(date, index, allDates, monthNumber, disabledDays) ?
                <div className='tableEntryDisabled' key={index}>
                  <CalendarTile
                    date={date}
                    index={index}
                    key={index}
                    isDisabled={true}
                    isShowDate={monthNumber === 0 ? true : false}
                    isInventoryDataPresent={this.isInventoryDataPresent(date, dates)}
                  />
                </div>
              :
                <div className='tableEntry' key={index}>
                  <CalendarTile
                    date={date}
                    index={index}
                    key={index}
                    isDisabled={false}
                    calendarInfo={this.getDateServicesRejections(date, responseDateArray)}
                    isShowDate={true}
                    isInventoryDataPresent={this.isInventoryDataPresent(date, dates)}
                  />
                </div>
          );
        
      });
    return finalResult;
  }

  renderWeekDays() {
    let result;
    result = WEEK_DAYS.map((day, index) => {
      return (
        <span className='dayNames' key={index}>{day}</span>
      );
    })
    return result;
  };

  getMonthName(monthDays) {
    const firstDay = monthDays && monthDays[0];
    return (moment(firstDay).format("MMMM YYYY"))
  }

  getMonthDates(month, allAvalilableDates) {
    let datesOfMonth = [];
    allAvalilableDates && allAvalilableDates.map((date) => {
      if (moment(date).format("MM").match(month)) {
        datesOfMonth.push(date);
      }
    });
    return datesOfMonth;
  }

  renderCalenderView(availableMonthsArray, allAvalilableDates, responseDateArray) {
    let result;
    result = availableMonthsArray.map((month, index)=>{
      const dates = this.getMonthDates(month, allAvalilableDates);
      return(
      <div>
       <div className='monthNameHeader'>
       <div className='monthName'>{this.getMonthName(dates)}</div>
       <div className='horizontalLine'></div>
     </div>
     <div className='weekDays'>
       {this.renderWeekDays()}
     </div>
     <div className='table'>
            {this.renderInventorycalendar(dates, responseDateArray, index)}
          </div>
     </div>
       );
  })
return result
}

  render() {
    const { inventoryCalendarViewData } = this.props;
    const responseDateArray = inventoryCalendarViewData && inventoryCalendarViewData.calendar_data;
    const allAvalilableDates = responseDateArray && responseDateArray.map(value => value.date);
    const availableMonths = responseDateArray && [...new Set(responseDateArray.map(value => value.date.split('-')[1]))];
    localStorage.setItem('inventory-calendar', JSON.stringify(responseDateArray))
    let currentmonthDates = [];
    let nextMonthDates= [];
    let afterNextMonthdates = [];
    const currentMonthNumber = availableMonths && availableMonths[0];
    const nextMonth = availableMonths && availableMonths[1];
    const afterNextMonth = availableMonths && availableMonths[2];
    allAvalilableDates && allAvalilableDates.map((date) => {
      if (moment(date).format("MM").match(currentMonthNumber)) {
        currentmonthDates.push(date);
      }
      else if (moment(date).format("MM").match(nextMonth)) {
        nextMonthDates.push(date);
      }
      else if (moment(date).format("MM").match(afterNextMonth)) {
        afterNextMonthdates.push(date);
      }
    });
    localStorage.setItem('current-month-dates', JSON.stringify(currentmonthDates))
    localStorage.setItem('next-month-dates', JSON.stringify(nextMonthDates))
    localStorage.setItem('after-month-dates', JSON.stringify(afterNextMonthdates))
    return (
      inventoryCalendarViewData && inventoryCalendarViewData.calendar_data ?
        <div className='inventoryContainer'>
          <div className='headerLhs'>
            <span className='headerText'>Inventory View</span>
          </div>
          {this.renderCalenderView(availableMonths, allAvalilableDates, responseDateArray)}
        </div>
        :
        null
    )
  }
}
const mapStateToProps = store => ({
  allRoutesInfo: store.userInfoReducer.allRoutesInfo,
  inventoryCalendarViewData: store.inventoryViewReducer.inventoryCalendarViewData,
})

const mapDispatchToProps = dispatch => ({
  fetchInventoryCalendarView: (payload, query) => dispatch(actions.fetchInventoryCalendarView(payload, query)),
})

export default connect(mapStateToProps, mapDispatchToProps)(InventorycalendarView)
